import * as React from "react";
import { TextInput as DefaultTextInput } from "react-native";
import { Controller } from "react-hook-form";
import useThemeColor from "../../hooks/useThemeColor";
import Text from "./Text";
import View from "./View";
import Colors from "../../constants/Colors";

type ThemeProps = {
  lightColor?: string;
  darkColor?: string;
  width?: number;
  label?: string;
  control: any;
  name: string;
  required?: boolean;
  errors: any;
  errorMessage?: string;
  rules?: any;
  min?: number;
};

export type InputProps = ThemeProps & DefaultTextInput["props"];

export default function Input(props: InputProps) {
  const {
    style,
    lightColor,
    darkColor,
    width,
    label,
    control,
    required,
    name,
    errors,
    errorMessage,
    rules = { required: required },
    min,
    ...otherProps
  } = props;

  const backgroundColor = useThemeColor(
    { light: lightColor, dark: darkColor },
    "background"
  );
  const color = useThemeColor({ light: darkColor, dark: lightColor }, "text");
  const _width = width || "100%";

  // Add min rule if min is provided
  const minRule =
    min !== undefined
      ? { min: { value: min, message: `Minimum value is ${min}` } }
      : {};
  const combinedRules = { ...rules, ...minRule };

  return (
    <Controller
      control={control}
      name={name}
      rules={combinedRules}
      render={({ field: { onChange, onBlur, value } }) => (
        <View
          style={{ justifyContent: "center", width: _width }}
          lightColor="transparent"
          darkColor="transparent"
        >
          {label && (
            <Text
              size={16}
              lineHeight={20}
              style={{
                alignSelf: "flex-start",
                marginBottom: 4,
              }}
              weight="Regular"
            >
              {label}
              {required && (
                <Text
                  size={16}
                  lightColor={Colors.go_danger_500}
                  darkColor={Colors.go_danger_500}
                >
                  *
                </Text>
              )}
            </Text>
          )}
          <DefaultTextInput
            onBlur={onBlur}
            onChangeText={onChange}
            value={value}
            allowFontScaling={false}
            maxFontSizeMultiplier={1}
            style={[
              {
                alignSelf: "flex-start",
                backgroundColor,
                color,
                paddingVertical: 8,
                paddingHorizontal: 12,
                borderRadius: 4,
                width: _width,
                borderColor: errors[name]
                  ? Colors.go_danger_200
                  : Colors.nuetral_grey_400,
                borderWidth: 1,
              },
              style,
            ]}
            {...otherProps}
          />
          {errors[name]?.type === "min" && (
            <Text
              lightColor={Colors.go_danger_500}
              darkColor={Colors.go_danger_500}
            >
              {errorMessage || `Minimum value is ${min}`}
            </Text>
          )}
        </View>
      )}
    />
  );
}
